import {memo} from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import {Link} from "react-router-dom";
import "./index.scss";


const CustomBreadcrumbs = ({config}) => {
    return (
        <Breadcrumbs className="breadcrumbs">
            <Link to="/" className="breadcrumbs__link">Главная</Link>
            {config.map(item =>
                item.path ?
                    <Link to={item.path} className="breadcrumbs__link" key={item.name}>{item.name}</Link> :
                    <p className="breadcrumbs__text" key={item.name}>{item.name}</p>
            )}
        </Breadcrumbs>
    );
}

export default memo(CustomBreadcrumbs);